import type { Puzzle } from '../api/types';

/**
 * Liefert die menschenlesbare Bezeichnung eines Rätsels:
 * - Sonder-Rätsel (mit Titel) → der Titel selbst, z.B. "ME/CFS Awareness".
 * - Normale Rätsel → `#<Nummer>`, z.B. "#477".
 *
 * Sonder-Rätsel haben in der DB synthetische Nummern ab 90001, die der
 * Spieler nicht sehen soll — daher Titel-first.
 */
export function puzzleLabel(puzzle: Pick<Puzzle, 'puzzle_number' | 'title'>): string {
  if (puzzle.title && puzzle.title.trim().length > 0) {
    return puzzle.title;
  }
  return `#${puzzle.puzzle_number}`;
}
